import React, { Component } from 'react';

import ModoPersonalizado from "./ModoPersonalizado";
import ConfiguracionBasica from "./ConfiguracionBasica";

const DetalleConfiguracionPersonalizada = (props) => {
    return (
        <div className="row">
            <div className="left-separator-xs panel panel-view">
                <div>
                    <label>
                        <i className="ti-panel panel-view-icon" />
                        <p>Personalizado</p>
                        <span>Administra usuarios, perfiles y permisos contemplando el directorio de usuarios y grupos de Windows.</span>
                    </label>
                </div>
            </div>
            <div className="col-xs-12 left-separator-xs">
                <ConfiguracionBasica cantIntentosFallidos={props.cantIntentosFallidos}
                    maxDiasCaducidad={props.maxDiasCaducidad}
                    maxDiasInactividad={props.maxDiasInactividad}
                    minutosPermitidosInactividad={props.minutosPermitidosInactividad}
                    cantidadRepeticiones={props.cantidadRepeticiones}/>
            </div>

            <div className="left-separator-xs">
                <ModoPersonalizado alfabetica={props.alfabetica}
                    caracteresEspeciales={props.caracteresEspeciales}
                    caracteresMinimos={props.caracteresMinimos}
                    caseSensitive={props.caseSensitive}
                    numerica={props.numerica}
                    permiteCaracteresIguales={props.permiteCaracteresIguales}
                    permiteLetrasConsecutivas={props.permiteLetrasConsecutivas}
                    permiteNrosConsecutivos={props.permiteNrosConsecutivos}
                    permiteRepetirPosicion={props.permiteRepetirPosicion}
                    plataformas={props.plataformas}/>
            </div>
        </div>
    );
};

export default DetalleConfiguracionPersonalizada;